import { profileOverrides } from '../data/profile';
import { SELF_ID, selfProfileOverride } from '../data/selfService';
import { isLicensed } from './teams';
import type { Employee, ProfileDetails } from '../types/hr';
import { nameById } from './employees';
import { formatDate } from './format';
import { getHRState } from './hrStore';

const EEO_BY_DEPARTMENT: Record<string, string> = {
  Sales: 'Sales Workers',
  Operations: 'Administrative Support Workers',
  Processing: 'Administrative Support Workers',
  Closing: 'Administrative Support Workers',
  Underwriting: 'Professionals',
  Marketing: 'Professionals',
  IT: 'Professionals',
  Finance: 'Professionals',
  HR: 'Professionals',
};

export function getProfileDetails(employee: Employee): ProfileDetails {
  const saved = getHRState().details[employee.id];
  if (saved) return saved;

  const num = Number(employee.employeeNumber.replace(/\D/g, '')) % 100;
  const first = employee.firstName.toLowerCase();
  const last = employee.lastName.toLowerCase();
  const hire = formatDate(employee.hireDate);
  const isSales = employee.department === 'Sales';

  const base: ProfileDetails = {
    address: {
      street1: `${100 + num * 7} Example Ave`,
      street2: num % 3 === 0 ? 'Apt 4B' : '',
      city: 'Sampletown',
      state: 'NY',
      zip: '11000',
      country: 'United States',
    },
    homePhone: `(718) 555-01${String(num).padStart(2, '0')}`,
    homeEmail: `${first}.${last}@home-demo.example.com`,
    social: { linkedin: `linkedin.com/in/${first}-${last}-demo`, facebook: '', instagram: '' },
    education: [
      { id: 'ed-default', institution: 'Sampletown State University', degree: "Bachelor's", major: isSales ? 'Finance' : 'Business Administration', gpa: '3.4', start: '2010', end: '2014' },
    ],
    eeoCategory: EEO_BY_DEPARTMENT[employee.department] ?? 'Professionals',
    veteran: [],
    company: 'Madison Mortgage (Demo)',
    compensationModel: isSales ? 'Base + Commission' : 'Salary',
    nmls: isLicensed(employee) ? `${String(num).padStart(6, '0')}-DEMO` : 'Not licensed',
    employmentStatus: [{ date: hire, status: employee.employmentType, comment: 'New hire' }],
    compensation: [
      { date: hire, schedule: 'Semi-monthly', payType: 'Salary', rate: `$${48 + num},000.00 / yr`, overtime: 'Exempt', otRate: '—', reason: 'New hire', comment: '—' },
    ],
    jobInfo: [
      { date: hire, location: employee.location, division: employee.division, department: employee.department, teams: '—', title: employee.jobTitle, reportsTo: nameById(employee.managerId) },
    ],
    commission: [],
    potentialBonus: [],
    bonus: [],
    equity: [],
  };

  return { ...base, ...(employee.id === SELF_ID ? selfProfileOverride : {}), ...(profileOverrides[employee.id] ?? {}) };
}
